import React, { useState, useEffect, useRef, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AppStateContext } from '../../../utils/contexts'
import { ekincareLogo, home_tab_icon, preemp_tab_icon, manage_emp_icon, invoices_icon, utilization_tab_icon, side_menu_arrow, analytics_icon, engagement, prelaunch, redCircle}  from '../../../assets/images';
import moment from 'moment';
import { Tooltip } from 'antd';
import { companyMailerApi } from '../../../services';
import { LAUNCH_MAILER_RELEASE_DATE } from '../../../constants/companyMailer';
import ahc_home from '../../../assets/images/ahc_home.svg'

const SideBarPill = ({ to, text, svgCode }) => {
  return (
    <div>
      <NavLink
        to={'/' + to}
        activeClassName='text-blue-600'
        className='text-gray-600 group w-full flex items-center pl-2 py-2 text-base leading-4 font-semibold rounded-md hover:text-blue-600 hover:bg-gray-100'
      >
        <img src={svgCode} alt='prefix-icon' />
        <span className='pl-3 font-semibold'>{text}</span>
      </NavLink>
    </div>
  );
};

const DropDownItem = ({ to, text }) => {
if(text){
    return (
      <NavLink
        to={to}
        activeClassName='text-blue-600 bg-gray-100 '
        className='group w-full font-semibold flex items-center pl-14 pr-2 py-2 text-sm font-proxima-nova text-gray-500 rounded-md hover:text-blue-600 hover:bg-gray-100'
      >
        {text}
      </NavLink>
    );
  }else{
    return (false);
  }
};

const DropDownMenu = ({title, list, icon}) => {
  const location = useLocation()
  const pathsList = useRef(list.map(item => item.to))
  const [showItems, setshowItems] = useState(pathsList.current.includes(location.pathname))

  useEffect(() => {
    setshowItems(pathsList.current.includes(location.pathname))
  }, [location.pathname])

  return (
    <div className='space-y-1 cursor-pointer'>
      <div
        className={`bg-white text-base leading-4  ${showItems ? 'text-blue-600': 'text-gray-600'} hover:text-blue-600 hover:bg-gray-100 group w-full flex items-center pl-2 pr-1 py-2 font-semibold rounded-md focus:outline-none focus:ring-0`}
        aria-controls='sub-menu-1'
        aria-expanded='false'
        onClick={() => {
          setshowItems(flag => !flag);
        }}
      >
        <img src={icon} alt='prefix-icon' />
        <span className='pl-3 font-semibold'>{title}</span>
        <img 
          alt='arrow-icon' 
          src={side_menu_arrow} 
          className={`text-gray-300 ml-auto h-3 w-3 transform group-hover:text-gray-400 transition-colors ease-in-out duration-500  ${showItems ? 'rotate-90' : ''}`} 
        />
      </div>
       {showItems && <div className='space-y-1' id='sub-menu-1'>{list.map(({ to, text, show = true }) => show && <DropDownItem key={text} to={to} text={text} />)}</div>}
    </div>
  );
}

const SideBar = ({ children, previousState, benefitList, isBenefitListLoaded }) => {

const OtherBenefitPaths = [
  { to: 'doctor-consultation', text: 'Doctor Consultation' },
  { to: 'health-risk-assessment', text: 'Health Risk Assessment' },
  { to: 'pharmacy', text: 'Pharmacy' },
  { to: 'vaccination', text: 'Vaccination' },
  { to: 'gym-and-fitness', text: 'Gyms and Fitness' },
  { to: 'health-coach-programs', text: 'Health Coach Programs' },
];

  const [mailSent, setMailSent] = useState({sent: true, post: false, sent_at: null});
  const role = (previousState.role || '').toLowerCase().replace(/ /g, '_')
  const { showSpendingAccount, showAddIcon, showFamilyIcon, showDeleteIcon } = useContext(AppStateContext)
  const mergedBenefitList = [{ to: 'spending-account', text: 'Spending Account', show: showSpendingAccount }, ...benefitList, ...OtherBenefitPaths];
  let launch_date = sessionStorage.getItem('launch_date');
  let digitization = previousState.digitization;
  
  // Exclude 'Health checks' when digitization is not 'full' 
  let analyticsSubmenuList = [
      (digitization === 'digitization_disable' ? {to: '', text: ''} : {to:'/test-results', text:'Health checks'}),
      {to:'/mental-wellness', text:'Mental wellness '},
      {to:'/health-risks', text:'Health risks'},
      {to:'/demographics', text:'Demographics'},
      {to:'/challenges', text:'Challenges'},
      {to:'/steps', text:'Steps'},
      (mailSent.post ? (mailSent.sent_at ? {to:'/mailer', text:'Pre Launch'} : {to: '', text: ''}) : {to: '', text: ''}),
      {to:'/mis-pulse', text: 'Mis Pulse'}
    ];
  let is_active = sessionStorage.getItem('is_active')
  const isChildCompany = JSON.parse(sessionStorage.getItem('is_child_company'));
  useEffect(() => {
    if(is_active === 'inactive' && role === 'staff'){
      setMailSent((prev) => {return{...prev, ...{sent: false}}})
    }
    else {
      if(launch_date > LAUNCH_MAILER_RELEASE_DATE && ['staff', 'csm'].includes(role)) {
        companyMailerApi.post_pre_launch({} , 
          (res) =>{
            let data = res.data
            if(moment(new Date()).format('YYYY-MM-DD') >= moment(data?.sent_at).add(30, 'days').format('YYYY-MM-DD')){
              setMailSent((prev) => {return{...prev, ...{post: true, sent_at: data?.sent_at}}})
            }
          },
          (error) => {
            let launch_date = sessionStorage.getItem('launch_date')
            if(moment(new Date()).format('YYYY-MM-DD') > moment(launch_date).add(90, 'days').format('YYYY-MM-DD')){
              setMailSent((prev) => {return{...prev, ...{sent: true, post: true, sent_at: null}}})
            } else {
              setMailSent((prev) => {return{...prev, ...{post: false}}})
            }
          }
      )
    }
    setMailSent((prev) => {return{...prev, ...{sent: true}}})
  }
  },[])

  const companies = JSON.parse(sessionStorage.getItem('companies')) || [];
  const companyId = sessionStorage.getItem('company_id');
  const enablePpmc = companies.find(item => item.id == companyId)?.enable_ppmc;

  return (
    <div className='flex overflow-hidden min-h-screen'>
      <div className='flex flex-col border-r border-gray-200 pt-6 pb-4 bg-white w-64 fixed h-full z-20'>
        <div className='flex items-center flex-shrink-0 pl-6'>
          <img src={ekincareLogo} alt='ekincare' />
        </div>
        <div className='flex-grow flex flex-col overflow-y-auto mt-10'>
          
          <nav className='flex-1 px-3 space-y-1 bg-white' aria-label='Sidebar'>
            <div style={(LAUNCH_MAILER_RELEASE_DATE < launch_date ? (mailSent.post ? {display: 'none'} : {display: 'block'}) : {display: 'none'})}>
              {['staff', 'csm'].includes(role) && (
                <SideBarPill to='mailer' text='Pre Launch' svgCode={prelaunch} />
              )}
            </div>

            <Tooltip
                placement='bottomLeft'
                overlayStyle={{maxWidth: '235px'}}
                color={'#0D1A35'}
                key='pink'
                title={`${mailSent.sent ? '' :'This feature will unlock after sending the official launch emailer'}`}
                align
              >
              <div>
                <div className={`${mailSent.sent ? '' : 'opacity-50 pointer-events-none'}`}>
              
              {!['regional_staff', 'preemp', 'preemprequest'].includes(role) && (
                <SideBarPill to='overview' text='Overview' svgCode={home_tab_icon} />
              )}
              {!['broker'].includes(role) && (
                <SideBarPill to='pre-employee-checkup' text='Pre Employment' svgCode={preemp_tab_icon} />
              )}
              {!['broker'].includes(role) && enablePpmc && (
                <SideBarPill to='ppmc-employee-checkup' text='Pre-Policy Medical Checkup' svgCode={preemp_tab_icon} />
              )}
              {['staff', 'sales', 'csm', 'csmmaster', 'broker'].includes(role) && (
                <div>
                { isBenefitListLoaded && (<DropDownMenu 
                                          title='Utilization' list={mergedBenefitList.map((benefit) => ({
                                          to: benefit.benefit_type ? `/utilization/${benefit.benefit_type}` : `/${benefit.to}`,
                                          text: benefit.benefit_name || benefit.text }))} 
                                          icon={utilization_tab_icon} />)}
                </div>
              )}
              {!['regional_staff', 'preemp', 'preemprequest', 'broker'].includes(role) && (
                <DropDownMenu title='Engagement' list={[{to:'/stepathon', text:'Stepathon'}, {to:'/wellness-calendar', text:'Calendar'}]} icon={engagement}/>
              )}
              {!['regional_staff', 'preemp', 'preemprequest'].includes(role) && (
                <DropDownMenu title='Analytics' list={analyticsSubmenuList} icon={analytics_icon}/>
              )}
                </div>
              </div>
            
              </Tooltip>
              {!['regional_staff', 'broker', 'preemp', 'csm', 'csmmaster', 'preemprequest'].includes(role) && (
                <DropDownMenu 
                  title={<span className='flex flex-row font-semibold'>Manage Employees{ (showAddIcon || showDeleteIcon || showFamilyIcon) && <img className='h-2 w-2 mt-1.5 ml-2 rounded-full' src={redCircle}/>}</span>} 
                  list={[{to: '/manage-employee', text: 'Employee list'},
                        {to:'/employee-registration', text:<span className='flex flex-row font-semibold'>Add Employees{ showAddIcon && <img className='h-2 w-2 mt-1.5 ml-2 rounded-full' src={redCircle}/>}</span> }, 
                        {to: '/deactivate-employees' , text :<span className='flex flex-row font-semibold'>Deactivate Employees{showDeleteIcon && <img className='h-2 w-2 mt-1.5 ml-2 rounded-full' src={redCircle}/>}</span> }, 
                        {to:'/family-registration', text:<span className='flex flex-row font-semibold'>Family Registration{ showFamilyIcon && <img className='h-2 w-2 mt-1.5 ml-2 rounded-full' src={redCircle}/>}</span>}]
                      } 
                  icon={manage_emp_icon} 
                />
              )}
              <Tooltip
                placement='bottomLeft'
                overlayStyle={{maxWidth: '235px'}}
                color='#0D1A35'
                key='red'
                title={`${mailSent.sent ? '' :'This feature will unlock after sending the official launch emailer'}`}
              >
                <div>
                  <div className={`${mailSent.sent ? '' : 'opacity-50 pointer-events-none'}`}> 
                    {['staff', 'csm', 'csmmaster', 'sales'].includes(role) && (
                    <SideBarPill to='invoices' text='MIS and Invoices' svgCode={invoices_icon} />
                    )}   
                  </div>
                </div>
                {sessionStorage.getItem('logged_in_company_id') === '100' && <div>
                  <div className={`${mailSent.sent ? '' : 'opacity-50 pointer-events-none'}`}> 
                    <SideBarPill to='provider-network' text='Provider Network Coverage' svgCode={ahc_home} />
                  </div>
                </div>}
            </Tooltip>
                 
          </nav>
        </div>
      </div>

      <main
        className='flex-1 relative overflow-y-auto focus:outline-none ml-64'
        tabIndex='0'
        style={{ backgroundColor: '#f6f7f9' }}
      >
        {children}
      </main>
    </div>
  );
};

export default SideBar
